import { useCallback, useEffect } from 'react'
import { useSelector } from '@/libs/state'
import { permissionUsers$ } from '../store'
import { permissions as permissionsPort } from '../wiring'

const usePermissionUsers = () => {
	const users = useSelector(permissionUsers$)

	const reload = useCallback(async () => {
		const result = await permissionsPort.listUsers()
		permissionUsers$.set(result)
	}, [])

	useEffect(() => {
		reload()
	}, [reload])

	return { users }
}

export { usePermissionUsers }
